import MonitoringServiceOrderBaseModal from './monitoring-service-order-base-detail-modal.vue'
export default MonitoringServiceOrderBaseModal
